/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

import { Box, Button, Container, Toolbar, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import SearchBar from "../../Components/Shared/SearchBar";
import UserDialog from "../../Components/User/UserDialog";
import UserList from "../../Components/User/UserList";
import { useGetAllUserQuery } from "../../Store/Services/UserService";
import { openAddUserModal } from "../../Store/Slices/userSlice";

import styles from "./Management.module.css";

const UserManagement = () => {
  const dispatch = useDispatch();
  const [roles, setRoles] = useState("");

  useEffect(() => {
    const getRoles = () => {
      if (typeof window !== undefined) {
        setRoles(sessionStorage.getItem("role"));
      }
    };
    getRoles();
  }, []);

  const [searchData, setSearchData] = useState([]);
  const { data, isSuccess, isLoading, isError, error } = useGetAllUserQuery();

  useEffect(() => {
    if (isLoading) {
      console.log("Loading data...");
    } else if (isError) {
      console.error("Error fetching data:", error);
    } else if (isSuccess) {
      console.log("Fetched data:", data);
    }
  }, [data, isSuccess, isLoading, isError, error]);

  return (
    <>
      {roles?.split(",").includes("PRIV_ECOM_USERDISPLAY") && (
        <div className={styles.pageContainer}>
          <div>
            <Toolbar className={styles.subNavBar}>
              <Typography className={styles.topic}>User Management</Typography>
              <Button
                variant="contained"
                color="primary"
                className={styles.buttonItem}
                onClick={() => dispatch(openAddUserModal())}
              >
                Add New
              </Button>
            </Toolbar>
          </div>

          <Container id={styles.container}>
            <SearchBar
              data={isSuccess && data ? data : []}
              setSearchData={setSearchData}
              text="Search Users"
              search="user"
            />
          </Container>
          <Container>
            {isSuccess && (
              <UserList
                data={
                  Array.isArray(searchData) && searchData.length > 0
                    ? searchData
                    : data
                }
              />
            )}
          </Container>
          <UserDialog />
        </div>
      )}
    </>
  );
};

export default UserManagement;
